import React from 'react';

interface SessionReplacedModalProps {
  isOpen: boolean;
  device?: string;
}

export const SessionReplacedModal: React.FC<SessionReplacedModalProps> = ({
  isOpen,
  device
}) => {
  const handleLogIn = () => {
    // Limpiar almacenamiento local
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    
    // Redirigir a login
    window.location.href = '/login';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Sesión Cerrada</h3>
          <button
            onClick={handleLogIn}
            className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Icono de advertencia */}
          <div className="flex justify-center">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
              <svg
                className="w-6 h-6 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4v2m0 4v2M3.712 4.231a1 1 0 00-.712.989v14.016a1 1 0 00.712.989l8.288 2.734a1 1 0 00.696 0l8.288-2.734a1 1 0 00.712-.989V5.22a1 1 0 00-.712-.989l-8.288-2.734a1 1 0 00-.696 0L3.712 4.231z"
                />
              </svg>
            </div>
          </div>

          {/* Mensaje principal */}
          <div className="text-center">
            <p className="text-gray-900 font-medium mb-2">
              Tu sesión fue cerrada en otro dispositivo
            </p>
            <p className="text-sm text-gray-600">
              {device
                ? `Se inició una nueva sesión desde ${device}.`
                : 'Se inició una nueva sesión desde otro dispositivo.'}
            </p>
          </div>

          {/* Mensaje adicional */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-xs text-blue-700">
              Por seguridad, solo se permite una sesión activa por usuario. Si no fuiste tú quien inició sesión en otro dispositivo, considera cambiar tu contraseña.
            </p>
          </div>

          {/* Botón de acción */}
          <button
            onClick={handleLogIn}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Iniciar sesión de nuevo
          </button>
        </div>
      </div>
    </div>
  );
};
